export function isLikelyUrl(text: string | undefined): boolean {
  if (!text) return false;
  try {
    const url = new URL(text.trim());
    return url.protocol === 'http:' || url.protocol === 'https:';
  } catch (_) {
    return false;
  }
}

